import { render, staticRenderFns } from "./ChooseExam.vue?vue&type=template&id=ca608762&scoped=true&"
import script from "./ChooseExam.vue?vue&type=script&lang=js&"
export * from "./ChooseExam.vue?vue&type=script&lang=js&"
import style0 from "./ChooseExam.vue?vue&type=style&index=0&id=ca608762&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca608762",
  null
  
)

export default component.exports